import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"

import styles from "./styles.css"

import { selectStatusColor, status } from "../../../constants"

const classes = {
  loading: styles.loading,
  success: styles.success,
  cancel: styles.cancel,
  schedule: styles.schedule,
  reschedule: styles.reschedule,
  suspended: styles.suspended,
  disapproved: styles.disapproved,
  default: styles.defaultClass
}

const BadgeFixedVoice = ({ type, data, isDash, isDataNumber }) => {
  const statusColors = selectStatusColor(type)

  return (
    <div className={classnames({ [styles.dash]: isDash })}>
      <span className={classnames(styles.defaultClass, classes[statusColors])}>
        {isDataNumber ? data : status[type]}
      </span>
    </div>
  )
}

BadgeFixedVoice.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.any.isRequired,
  isDash: PropTypes.bool,
  isDataNumber: PropTypes.bool
}

export default BadgeFixedVoice



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/BadgeFixedVoice/index.js